/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Offline_At_TimeInputs */

const en_us2_offline_at_time = /** @type {(inputs: Offline_At_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`at ${i?.time}`)
};

const pt_br2_offline_at_time = /** @type {(inputs: Offline_At_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`às ${i?.time}`)
};

const es_419_offline_at_time = /** @type {(inputs: Offline_At_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`a las ${i?.time}`)
};

const pt_pt2_offline_at_time = /** @type {(inputs: Offline_At_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`às ${i?.time}`)
};

const fr_fr2_offline_at_time = /** @type {(inputs: Offline_At_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`à ${i?.time}`)
};

const de_de2_offline_at_time = /** @type {(inputs: Offline_At_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`um ${i?.time}`)
};

const it_it2_offline_at_time = /** @type {(inputs: Offline_At_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`alle ${i?.time}`)
};

/**
* | output |
* | --- |
* | "at {time}" |
*
* @param {Offline_At_TimeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_at_time = /** @type {((inputs: Offline_At_TimeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_At_TimeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_at_time(inputs)
	if (locale === "es-419") return es_419_offline_at_time(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_at_time(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_at_time(inputs)
	if (locale === "de-DE") return de_de2_offline_at_time(inputs)
	if (locale === "it-IT") return it_it2_offline_at_time(inputs)
	return en_us2_offline_at_time(inputs)
});
export { offline_at_time as "offline.at_time" }